// extracted by mini-css-extract-plugin
export default {"boardsContextMenu":"HJRjxZ"};